import { Box, Grid, Theme, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ShopsInfo } from '../../../model/shops.response';
import { getShortHoursOfOperation } from '../../../utils/Utilities';

interface Shop {
  shop: ShopsInfo;
}

const ShopHoursAndDistance = (prop: Shop) => {
  const theme: Theme = useTheme();
  return (
    <Grid
      container
      justifyContent="flex-start"
      alignItems="stretch"
      spacing={4}
      title="ShopHoursAndDistance"
      tabIndex={0}
    >
      <Grid item xs={6} md={6}>
        <Box
          sx={{
            width: '100%',
            borderRight: '1px solid #707070', // Always show border
            marginBottom: '1rem',
            height: '100%',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: {
                ...theme.custom.styles.primaryDescription,
                fontSize: '14px',
                padding: '0px 10px 0px 15px',
              },
            }}
          >
            {'Opening Hours'}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: {
                ...theme.custom.styles.primaryDescription,
                fontSize: '14px',
                fontWeight: 700,
                paddingLeft: '10px',
                whiteSpace: 'pre-line',
                padding: '0px 10px 0px 15px',
              },
            }}
          >
            {prop.shop.hoursOfOperation && getShortHoursOfOperation(prop.shop.hoursOfOperation)}
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={6} md={6}>
        <Box sx={{ width: '100%', height: '100%' }}>
          <Typography
            variant="body2"
            sx={{
              color: {
                ...theme.custom.styles.primaryDescription,
                fontSize: '14px',
                padding: '0px 10px 0px 10px',
              },
            }}
          >
            {'Distance Away'}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: {
                ...theme.custom.styles.primaryDescription,
                fontSize: '14px',
                fontWeight: 700,
                paddingLeft: '10px',
                whiteSpace: 'pre-wrap',
                padding: '0px 10px 10px 10px',
              },
            }}
          >
            {`${prop.shop.distanceInfo.distance} miles`}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ShopHoursAndDistance;
